/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetCloudIcon24Solid = forwardRef('NetCloudIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M11.1 3a6.6 6.6 0 0 1 5.981 3.806A6.6 6.6 0 0 1 16.801 20c-.001 0 0 0 0 0H6.6A6 6 0 0 1 4.62 8.334 6.602 6.602 0 0 1 11.1 3Z" })));
});
